import { Suspense, useState, Fragment } from "react";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { EXAMPLES } from "./examples/registry";
import { GuidePreview } from "./guide-preview";
import type { GuideExampleKind } from "./types";

export const GuideExample = ({
  kind,
  task,
  id = "guide-example",
  interactive = true,
}: {
  id?: string;
  kind: GuideExampleKind;
  task: string;
  interactive?: boolean;
}) => {
  const [version, setVersion] = useState(0);
  return (
    <GuidePreview
      id={id}
      caption={task}
      onReset={interactive ? () => setVersion((value) => value + 1) : undefined}
    >
      <Suspense
        fallback={
          <Stack
            direction="row"
            align="center"
            gap={2}
            role="status"
            className="p-4"
          >
            <Spinner layout="centered" />
            <Text>Loading example…</Text>
          </Stack>
        }
      >
        <Fragment key={`${kind}-${version}`}>{EXAMPLES[kind]}</Fragment>
      </Suspense>
    </GuidePreview>
  );
};
